import { Form, message } from "antd";
import useAuth from "../../hooks/useAuth";
import useModal from "../../hooks/useModal";
import { updateUser } from "../../services/users";
import useLoading from "../../hooks/useLoading";
import useCustomUpload from "../../hooks/useUpload";
import { deleteFile, downloadFile } from "../../services/files";
import { useEffect, useState } from "react";

function useProfile() {
  const [form] = Form.useForm();
  const userModal = useModal();
  const { userData, getUserData } = useAuth();
  const updateLoading = useLoading();
  const [url, setUrl] = useState<string | undefined>("");

  const { cleanUploads, handleUpload, handleFileChange, uploads } =
    useCustomUpload();

  useEffect(() => {
    getUrl();
  }, []);

  const getUrl = async () => {
    const uri = await downloadFile(userData?.profilePicture, "image");
    setUrl(uri);
  };

  const handleEdit = () => {
    userModal.openModal();
    form.setFieldsValue({
      ...userData,
    });
  };

  const handleOk = async () => {
    let path;
    try {
      updateLoading.start();

      let upload;

      upload = await handleUpload({
        name: "photo",
        category: "users",
        required: true,
        editing: true,
      });
      path = upload.path;
      const data = form.getFieldsValue();

      await updateUser({
        ...data,
        id: userData?.id,
        profilePicture: upload?.path || userData.profilePicture || "",
      });
      await getUserData();
      handleCancel();
    } catch (error: Error | any) {
      if (error.message === "El archivo es requerido.") {
        message.error("La foto de perfil es requerida");
      }
      if (path) {
        await deleteFile(path);
      }
    } finally {
      updateLoading.stop();
    }
  };

  const handleCancel = () => {
    userModal.closeModal();
    form.resetFields();
    cleanUploads();
  };

  return {
    form,
    handleCancel,
    handleEdit,
    handleFileChange,
    handleOk,
    loading: updateLoading.loading,
    uploads,
    user: userData,
    userModal,
    url,
  };
}

export default useProfile;
